import React, { useState, useRef } from "react";
import PropTypes from 'prop-types';
import { Modal, Typography, message } from "antd";
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import { setUserData } from '../../../redux/CrmReduxCalls/LocalDataReduxStore';
import { Button } from '../../../components/buttons/buttons';
import { createCurrency } from '../../../Api/Services/CommonApiService';
import { updateUserProfile } from '../../../Api/Services/UserApiService';
import { getCompanyByUser, CompanyUpdate } from '../../../Api/Services/CompanyApiService';

const { Title, Paragraph } = Typography;

const CRMStartModal = ({ open, setOpen, }) => {
    const [disable, setDisable] = useState(false)
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const loadingRef1 = useRef(false);
    const [deleteClick1, setDelteClick1] = useState(false)
    const dispatch = useDispatch();
    const history = useHistory();
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    async function companyDetailsApi2(type) {
        const CompanyDetails = await getCompanyByUser()
        dispatch(setUserData({
            company: CompanyDetails
        }));
        if (type === "Skip") {
            setOpen(false)
        } else {
            setOpen(false)
            history.push("/Home/multi-currency")
        }
    }
    const fallbackCurrency = {
        decimalOfCurrency: 2,
        currency: "USD",
        currencyName: "US Dollar",
        exchangeRate: 1,
        exchangeRateSetting: "Manual",
        refreshSchedule: "Not Applicable",
        symbol: "$",
    };
    const saveAndNext = async (type) => {
        if (type === "Submit") {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setDelteClick(true)
        } else {
            if (loadingRef1.current) return;
            loadingRef1.current = true;
            setDelteClick1(true)
        }
        setDisable(true)
        const payload = {
            symbol: "$",
            currencyName: "US Dollar",
            defaultCurrency: "USD",
            decimalOfCurrency: 2,
            currency: [{
                "currencyName": "US Dollar",
                "currency": "USD",
                "exchangeRateSetting": "Manual",
                "refreshSchedule": "Not Applicable",
                "exchangeRate": 1,
                "symbol": "$",
            }]
        }
        const hideMessage = message.loading("Updating currency...", 0);
        const response = await createCurrency(payload)
        if (response.status === 201) {
            dispatch(setUserData({
                currency: fallbackCurrency,
                defaultCurrecny: {
                    decimalOfCurrency: 2,
                    ...({
                        "currencyName": "US Dollar",
                        "currency": "USD",
                        "exchangeRateSetting": "Manual",
                        "refreshSchedule": "Not Applicable",
                        "exchangeRate": 1,
                        "symbol": "$",
                    }),
                }
            }));
            const formData =
            {
                currency: {
                    currency: "USD",
                    currencyName: "US Dollar"
                }
            };
            await updateUserProfile(formData);
            const payloads =
            {
                loginSetupStatus: "Finish"
            }
            const responses = await CompanyUpdate(payloads, companyProfile.companyId)
            if (responses.data.statusCode === 200) {
                companyDetailsApi2(type)
            }
            setDisable(false)
            hideMessage();
            loadingRef.current = false;
            setDelteClick(false)
            loadingRef1.current = false;
            setDelteClick1(false)
        } else {
            loadingRef.current = false;
            setDelteClick(false)
            loadingRef1.current = false;
            setDelteClick1(false)
            setDisable(false)
            hideMessage();
        }
    }
    return (
        <Modal
            open={open}
            centered
          footer={false}
            closable={false}
            title={null}
            width={600}
            bodyStyle={{
                padding: "40px 60px",
                textAlign: "center",
            }}
            style={{
                maxWidth: "90vw",
            }}
        >

            <div style={{ marginBottom: 20 }}>
                <Title level={3} style={{ color: "#666", marginBottom: 8 }}>
                    Set your Base Currency
                </Title>
            </div>
            <div style={{ textAlign: 'left' }}>
                <div>
                    <Paragraph> Your base currency is used for all deals, forecasts and reports. It&lsquo;s currently set to <strong>USD (United States Dollar)</strong>.</Paragraph>
                </div>
                <div>
                    <Paragraph> Once deals are added, or additional currencies are enabled,<strong> the base currency cannot be changed</strong>.</Paragraph>
                </div>
                <div>
                    <Paragraph> If you want to use a different base currency, you can update it now from the Multi-Currency Settings page.</Paragraph>
                </div>
            </div>
            <div className="form_action_button" style={{ marginTop: 40 }}>
                <Button disabled={disable || deleteClick1} loading={deleteClick1}
                    className="button_outlined" size="small"
                    onClick={() => { saveAndNext("Skip") }}
                >Skip and Close
                </Button>
                <Button disabled={disable || deleteClick} loading={deleteClick}
                    size="small"
                    className="button_colors"
                    onClick={() => { saveAndNext("Submit") }}
                >Configure Currency now
                </Button>
            </div>
        </Modal>
    );
};
CRMStartModal.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
};
export default CRMStartModal;
